__turbopack_context__.v({
  "buttons-wrapper": "ImageCarousel-module-scss-module__P2frxa__buttons-wrapper",
  "dropdown-icon": "ImageCarousel-module-scss-module__P2frxa__dropdown-icon",
  "dropdown-icon-left": "ImageCarousel-module-scss-module__P2frxa__dropdown-icon-left",
  "dropdown-icon-right": "ImageCarousel-module-scss-module__P2frxa__dropdown-icon-right",
  "icon": "ImageCarousel-module-scss-module__P2frxa__icon",
  "image-container-inner": "ImageCarousel-module-scss-module__P2frxa__image-container-inner",
  "image-container-outer": "ImageCarousel-module-scss-module__P2frxa__image-container-outer",
  "image-toggle-btn": "ImageCarousel-module-scss-module__P2frxa__image-toggle-btn",
  "image-toggle-btn-icon": "ImageCarousel-module-scss-module__P2frxa__image-toggle-btn-icon",
  "image-toggle-btn-selected": "ImageCarousel-module-scss-module__P2frxa__image-toggle-btn-selected",
});
